
<div class="mat-dialog-header">
  <div class="mat-dialog-title">
    SFTP Account
  </div>
  <fa-icon (click)="dialogRef.close()" [icon]="['fas', 'close']"></fa-icon>
</div>
<div mat-dialog-content>
  <p><b>Host</b>: sftp://{{ sftpHost }}</p>
  <p><b>Port</b>: {{ sftpPort }}</p>
  <p><b>Account ID</b>: {{ sftpAccount.accountId }}</p>
  <button
    *ngIf="!resetStart && !accountCredentials"
    mat-button
    class="reset-password-button"
    (click)="startAccountReset()">
    Reset Password
  </button>
  <div *ngIf="resetStart" >
    <app-warning-banner-component
        bannerClass="custom-banner-container">
        <span class="banner-text">
          After password reset, the integration must be set again to work properly.
        </span>
      </app-warning-banner-component>
    <mat-form-field class="full-width-input">
      <mat-label>Type "RESET" to Update Password</mat-label>
      <input
        matInput
        [(ngModel)]="resetValidator"
      />
    </mat-form-field>
    <div class="actions">
      <button mat-button (click)="closeDialog()" class="modal-cancel-button">Cancel</button>
      <button
        [disabled]="resetValidator?.trim() !== 'RESET'"
        type="submit"
        mat-flat-button
        class="modal-delete-button"
        (click)="resetAccountPassword()">
        Reset Password
      </button>
    </div>
  </div>
  <!-- buttons for downloading credentials and copy to clipboard, and close -->
  <div *ngIf="accountCredentials" class="button-row">
    <div class="account-password">
      <b>Password</b>: {{ accountCredentials.accountPassword }}
    </div>
    <div class="actions">
      <button mat-flat-button color="primary" (click)="downloadCredentials()" class="standard-button">
        <fa-icon [icon]="['fas', 'download']"></fa-icon>
        Download
      </button>
      <button mat-flat-button color="primary" (click)="copyCredentials()" class="standard-button">
        <fa-icon [icon]="['fas', 'copy']"></fa-icon>
        Copy
      </button>
      <button
        *ngIf="credentialsSaved"
        mat-flat-button
        class="standard-button modal-cancel-button"
        (click)="closeDialog()">
        <fa-icon [icon]="['fas', 'times']"></fa-icon>
        Close
      </button>
    </div>
  </div>
</div>

